/**
 * Logger centralizado. En producción solo se emiten warn/error;
 * debug/info quedan silenciados. Preparado para integrar Sentry más adelante.
 */
const isProd = process.env.NODE_ENV === "production";

const noop = () => {};

export const logger = {
  debug: isProd ? noop : (...args) => console.debug(...args),
  info: isProd ? noop : (...args) => console.info(...args),
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
